module.exports = __webpack_public_path__ + "public/Icons/deleteIcon.svg?59f23149";